/* onlyQ Produkt-Berater - Logik
   Liest die Fragen und Ergebnisse aus dem JSON-Block im Abschnitt. */
(function () {
  function initQuiz(root) {
    if (!root || root.dataset.oqReady === 'true') return;
    root.dataset.oqReady = 'true';

    var dataEl = root.querySelector('script[type="application/json"][data-oq-data]');
    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var questions = DATA.questions || [];
    var results = DATA.results || [];
    if (!questions.length || !results.length) return;

    var weights = String(DATA.weights || '3,2,1,1').split(',').map(function (w) {
      var n = parseFloat(w.trim());
      return isNaN(n) ? 1 : n;
    });

    var modal = root.querySelector('[data-oq-modal]');
    var fill = root.querySelector('[data-oq-fill]');
    var progressText = root.querySelector('[data-oq-progress-text]');
    var qStep = root.querySelector('[data-oq-step-question]');
    var rStep = root.querySelector('[data-oq-step-result]');
    var qTitle = root.querySelector('[data-oq-question]');
    var optionsBox = root.querySelector('[data-oq-options]');
    var backBtn = root.querySelector('[data-oq-back]');

    var state = { index: 0, answers: [] };
    var lastFocus = null;

    function escapeHtml(str) {
      return String(str)
        .split('&').join('&amp;')
        .split('<').join('&lt;')
        .split('>').join('&gt;')
        .split(String.fromCharCode(34)).join('&quot;');
    }

    /* Text zwischen Sternchen wird kursiv in der Akzentfarbe gesetzt */
    function renderTitle(str) {
      var parts = escapeHtml(str).split('*');
      var out = '';
      for (var i = 0; i < parts.length; i++) {
        out += (i % 2 === 1) ? '<em>' + parts[i] + '</em>' : parts[i];
      }
      return out;
    }

    function renderQuestion() {
      var q = questions[state.index];
      if (!q) return;

      qStep.hidden = false;
      rStep.hidden = true;

      var pct = Math.round((state.index / questions.length) * 100);
      fill.style.width = Math.max(pct, 6) + '%';
      progressText.textContent = (DATA.progressLabel || 'Frage {n} von {total}')
        .replace('{n}', state.index + 1)
        .replace('{total}', questions.length);

      qTitle.innerHTML = renderTitle(q.title);

      optionsBox.innerHTML = '';
      (q.options || []).forEach(function (opt, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'oq-option';
        btn.innerHTML = '<span class="oq-option-bullet"></span><span>' + escapeHtml(opt.label) + '</span>';
        btn.addEventListener('click', function () { answer(opt.profile); });
        optionsBox.appendChild(btn);
        if (i === 0) setTimeout(function () { btn.focus(); }, 40);
      });

      backBtn.style.visibility = state.index === 0 ? 'hidden' : 'visible';
    }

    function answer(profile) {
      state.answers[state.index] = profile;
      if (state.index < questions.length - 1) {
        state.index++;
        renderQuestion();
      } else {
        showResult();
      }
    }

    function pickResult() {
      var score = {};
      state.answers.forEach(function (profile, i) {
        if (!profile) return;
        var w = typeof weights[i] === 'number' ? weights[i] : 1;
        score[profile] = (score[profile] || 0) + w;
      });

      var best = null;
      var bestScore = -1;
      var firstAnswer = state.answers[0];

      Object.keys(score).forEach(function (key) {
        var s = score[key];
        /* Bei Gleichstand gewinnt die Antwort auf die erste Frage */
        if (s > bestScore || (s === bestScore && key === firstAnswer)) {
          bestScore = s;
          best = key;
        }
      });

      var match = results.filter(function (r) { return r.profile === best; })[0];
      if (!match) {
        match = results.filter(function (r) { return r.profile === DATA.fallbackProfile; })[0] || results[0];
      }
      return match;
    }

    function showResult() {
      var r = pickResult();

      fill.style.width = '100%';
      progressText.textContent = DATA.doneLabel || 'Fertig';

      root.querySelector('[data-oq-r-title]').textContent = r.title || '';
      root.querySelector('[data-oq-r-sub]').textContent = r.sub || '';

      var list = root.querySelector('[data-oq-r-list]');
      list.innerHTML = '';
      (r.features || []).forEach(function (f) {
        var li = document.createElement('li');
        li.appendChild(document.createTextNode(f));
        list.appendChild(li);
      });

      var cta = root.querySelector('[data-oq-r-cta]');
      cta.textContent = r.ctaLabel || 'Jetzt entdecken';
      cta.setAttribute('href', r.ctaUrl || '#');

      var second = root.querySelector('[data-oq-r-second]');
      if (r.secondLabel && r.secondUrl) {
        second.textContent = r.secondLabel;
        second.setAttribute('href', r.secondUrl);
        second.hidden = false;
      } else {
        second.hidden = true;
      }

      qStep.hidden = true;
      rStep.hidden = false;
      setTimeout(function () { cta.focus(); }, 40);

      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({ event: 'onlyq_quiz_result', profile: r.profile });
      }
    }

    function openQuiz(e) {
      if (e) e.preventDefault();
      lastFocus = document.activeElement;
      state = { index: 0, answers: [] };
      renderQuestion();
      modal.hidden = false;
      modal.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }

    function closeQuiz() {
      modal.classList.remove('is-open');
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest ? e.target.closest('[data-onlyq-quiz-open]') : null;
      if (opener) { openQuiz(e); return; }
      if (e.target.closest && e.target.closest('[data-oq-close]') && root.contains(e.target)) closeQuiz();
    });

    backBtn.addEventListener('click', function () {
      if (state.index > 0) { state.index--; renderQuestion(); }
    });

    root.querySelector('[data-oq-restart]').addEventListener('click', function () {
      state = { index: 0, answers: [] };
      renderQuestion();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeQuiz();
    });

    if (window.location.hash === '#quiz') setTimeout(openQuiz, 300);
  }

  function initAll() {
    document.querySelectorAll('.onlyq-quiz-root').forEach(initQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme-Editor: nach dem Neuladen eines Abschnitts erneut starten */
  document.addEventListener('shopify:section:load', initAll);
})();
